export default __webpack_public_path__ + "maps-examples-multiple-shapes-thumbnail-480-076d2ff4762ddc540d3f2533e09f860d.png";